import {twMerge, twMergeConfig} from '@local/config/tailwind/merge'
import {tv as nativeTv} from 'tailwind-variants'

export const cx = (...args) => twMerge(...args)
export const tv: typeof nativeTv = (options, config) => nativeTv(options, {...config, twMergeConfig})
